import React from 'react';
import FormHelperText from '@material-ui/core/FormHelperText';
import EquipmentCard from './EquipmentCard';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import './EquipementCard.css';

class EquipmentChoice extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      value: '',
    }
  }

  check = (value) => {
    this.props.emit(value)
    this.setState({value})
  }

  render() {
    return (
      <FormControl variant="outlined" fullWidth margin="normal" className="mt-4">
        <InputLabel shrink disableAnimation className="gie-label">{this.props.title}</InputLabel>
        <div className="row g-4 pt-2">
          <EquipmentCard emit={() => this.check('gas')}
                         className="col-12 col-lg-4"
                         title="Une chaudière gaz "
                         checked={this.state.value === 'gas'}/>
          <EquipmentCard emit={() => this.check('fioul')}
                         className="col-12 col-lg-4"
                         title="Une chaudière fioul "
                         checked={this.state.value === 'fioul'}/>
          <EquipmentCard emit={() => this.check('air_conditioning')}
                         className="col-12 col-lg-4"
                         title="Une climatisation "
                         checked={this.state.value === 'air_conditioning'}/>
          <EquipmentCard emit={() => this.check('heat_pump')}
                         className="col-12 col-lg-4"
                         title="Une pompe à chaleur "
                         width="15vw" checked={this.state.value === 'heat_pump'}/>
          <EquipmentCard emit={() => this.check('solar')}
                         className="col-12 col-lg-4"
                         title="Une production d'eau chaude solaire"
                         checked={this.state.value === 'solar'}/>
        </div>
        {this.props.gearError &&
            <FormHelperText error className="ms-1">Vous devez choisir un équipement</FormHelperText>}
      </FormControl>
    );
  }
}

export default (EquipmentChoice);
